import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import { useRef, useState } from 'react';
import BookInfoPodcast from '@/components/ui/book-info-podcast/BookInfoPodcast';
import BookBreadcrumbs from '@/components/ui/book-breadcrumbs/BookBreadcrumbs';
import BookTabs from '@/components/ui/book-tabs/BookTabs';
import ReviewsList from '@/components/ui/reviews-list/ReviewsList';
import QuoteCard from '@/components/ui/quote-card/QuoteCard';
import FormReview from '@/components/ui/form-review/FormReview';
import { getAuthorFullName } from '@/helpers/helpers';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IPodcastDetail } from '@/interfaces/podcastDetail.interface';
import { IReviews } from '@/interfaces/reviews.interface';
import { IQuotes, IQuotesData } from '@/interfaces/quotes.interface';
import { IBookPageForms } from '@/interfaces/bookPageForms';

import styles from './PodcastDetail.module.scss';

interface IPodcastDetailPage {
  book: IPodcastDetail;
  reviews: IReviews;
  quotes: IQuotes;
  isPodcastPage?: boolean;
  isReviewsPage?: boolean;
  isQuotesPage?: boolean;
  podcastsAllow?: number;
}

const PodcastDetail: FC<IPodcastDetailPage> = ({ book, reviews, quotes, isPodcastPage, isReviewsPage, isQuotesPage, podcastsAllow }) => {
  const bookFullAlias = `/podcasts/${`podcasts-alias`}/${book.alias}/`;

  const refReviewForm = useRef<HTMLDivElement>(null);
  const firstAuthorFullName = book.authors.length > 0 ? getAuthorFullName(book.authors[0].first_name, book.authors[0].middle_name, book.authors[0].last_name) : 'Неизвестен';
  const [isFormsActive, setIsFormsActive] = useState<IBookPageForms>({ reviewFrom: false });

  const SEO_TITLE = `${book.podcast_item.title} ${firstAuthorFullName} в подскате ${book.podcast.title} - бесплатно скачать или слушать`;
  const SEO_DESCRIPTION = `Слушать онлайн выпуск "${book.podcast_item.title}" ${firstAuthorFullName} в подскате "${book.podcast.title}". Бесплатно скачать любой эпизод подкаста в mp3 или прослушать в электронной библиотеке КучаКниг`;
  const SEO_CANONICAL = useGetUrlPath();
  const SEO_COVER = `https://kuchaknig.org/covers/${book.podcast_item.external_id}.jpg`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} cover={SEO_COVER}>
      <BookBreadcrumbs podcastTitle={book.podcast_item.title} bookTitle={book.podcast.title} bookAlias={book.podcast.alias} authorFullName={firstAuthorFullName} genres={[]} isPodcast isPodcastsItem createdAt={book.podcast_item.created_at} />

      <BookInfoPodcast book={book as any} formRef={refReviewForm} isPodcast setIsFormsActive={setIsFormsActive} isPodcastsFree={Number(podcastsAllow) === 1} />

      <BookTabs
        bookPageName="О подкасте"
        bookAlias={bookFullAlias}
        bookPage={isPodcastPage}
        reviewsPage={isReviewsPage}
        quotesPage={isQuotesPage}
        // reviews={!!reviews.data}
        reviews
        reviewsCount={reviews.total_count}
        quotes={quotes.data && quotes.data.length > 0}
        quotesCount={quotes.total_count}
      />

      {isPodcastPage && (
        <>
          <div className={styles.podcastTxt}>{book.podcast_item.description}</div>
          <div ref={refReviewForm}>
            <FormReview isReviewActive={isFormsActive.reviewFrom} bookId={book.id} bookAlias={book.alias} />
          </div>
        </>
      )}

      {isReviewsPage && (
        <>
          <div className={styles.titleWithButtons}>
            <div className={styles.titleWithButton__title}>Отзывы о книге «{book.podcast.title}»</div>
            <a href="#reviewForm" className={styles.titleWithButton__btn}>
              Добавить комментарий
            </a>
          </div>
          {!!reviews.data && <ReviewsList reviews={reviews} isReviewsPage={true} />}
          <div id="reviewForm">
            <FormReview bookId={book.id} bookAlias={book.alias} isReviewActive />
          </div>
        </>
      )}

      {isQuotesPage && (
        <>
          <div className={styles.titleWithButtons}>
            <div className={styles.titleWithButton__title}>Цитаты книги «{book.podcast.title}»</div>

          </div>

          <div className={styles.quotesWrap}>
            {quotes.data.map((quote: IQuotesData) => (
              <QuoteCard key={quote.id} quote={quote} />
            ))}
          </div>

        </>
      )}
      {/* <BookBreadcrumbs isBottom bookTitle={book.podcast_item.title} bookAlias={book.alias} authorFullName={firstAuthorFullName} genres={[]} isPodcast createdAt={book.podcast_item.created_at} /> */}
    </Layout>
  );
};

export default PodcastDetail;
